// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekGroupDraggableBlock-moduleCalendarGridWeekGroupDraggableBlock__RFYYf";
var _2 = "CalendarGridWeekGroupDraggableBlock-moduleblock__TjyQr CalendarGridWeekBlock-moduleCalendarGridWeekBlock__A0xR4";
export { _1 as "CalendarGridWeekGroupDraggableBlock", _2 as "block" }
